(function () {
    'use strict';

    angular
        .module('app')
        .factory('WorkflowInstanceDataService', WorkflowInstanceDataService);

    WorkflowInstanceDataService.$inject = ['DataService'];

    function WorkflowInstanceDataService(DataService) {
        return DataService('workflowinstance');
    }
})();